'use client';
import { useEffect } from 'react';
import { classes } from './utils';

export default function NotFound() {
  useEffect(() => {
    window.location.href = '/login';
  }, []);

  return <div className={classes.notFound}>Redirecting...</div>;
}
